/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createOurMissionSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.main,
      textAlign: 'center',
      padding: 'calc(100% * (100 / 1440)) calc(100% * (150 / 1440)) calc(100% * (120 / 1440))',
      overflow: 'hidden',
    },
    container: {
      maxWidth: '1140px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    title: {
      color: '#ffffff',
      marginBottom: '48px',
    },
    plxOurMission: {
      width: '100%',
    },
    text: {
      color: '#ffffff',
      '& > i': {
        fontStyle: 'normal',
        color: theme.palette.secondary.main,
      },
    },
  }),
);

export { createOurMissionSectionStyles };
